import PropTypes from "prop-types"
import { numberFormatter } from "helpers/formatters/numbers"
import { safeDivide } from "helpers/math"

function TooltipContent({ dot, style }) {
  return <div className="line-target-tooltip" style={style}>
    {!dot.noTitle && <div className="tooltip-title">Forecast</div>}
    <ul>
      <li>
        Approx Return (%)
        <div className="value">{numberFormatter(dot.y)}</div>
      </li>
      <li className="highlight">
        Target Risk (%)
        <div className="value">{numberFormatter(dot.x)}</div>
      </li>
      <li>
        Approx Sharpe
        <div className="value">{numberFormatter(safeDivide(dot.y, dot.x))}</div>
      </li>
    </ul>
    {dot.label
      && <div className="tooltip-legend" style={{ background: dot.color }}>
        {dot.label}
      </div>}
  </div>
}

TooltipContent.propTypes = {
  dot: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired,
}

export default TooltipContent
